import * as Sentry from "@sentry/react";

import { createLocalAxios } from "../../lib/api.js";
import apiMessages from "../../lib/apiMessages.js";

import { loading, loadingDone } from "./slice.js";

export const fetchTabletRegistrationStatusById =
  (id) => async (dispatch, getState) => {
    dispatch(loading());

    const localAxios = createLocalAxios(getState);
    const url = `tablet-registration/check-status/${id}`;

    let response;
    try {
      response = await localAxios.get(url);
    } catch (error) {
      console.error(
        "Error while fetching the tablet registration status:",
        error,
      );
      throw error;
    } finally {
      await dispatch(loadingDone());
    }

    return response.data;
  };

export const registerTablet = (body) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = "tablet-registration/register-device";

  let response;
  try {
    response = await localAxios.post(url, body);
  } catch (error) {
    console.error("Error while registering the tablet:", error);
    Sentry.captureException(
      new Error(`Something went wrong: registerTablet post-> ${error}`),
    );
    throw error;
  }

  if (response.data.message !== apiMessages.MSG_SUCCESS) {
    throw new Error(response.data.message);
  }

  return response;
};

export const fetchTabletRegistrationSuggestions =
  (value) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);

    const url = `tablet-registration/suggest/${value}`;

    let response;
    try {
      response = await localAxios.get(url);
    } catch (error) {
      console.error(
        "Error while fetching the tablet registration suggestions:",
        error,
      );
      new Error(
        `Something went wrong: fetchTabletRegistrationSuggestions get -> ${error}`,
      );
    }

    return response.data;
  };
